<template lang="">
    <div>
    <div class="basic-2">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-xl-5">
                <div class="text-container">
                    <div class="section-title">ABOUT US</div>
                    <h2>We have ten years experience in marketing</h2>
                    <p>We are here from a decade providing the best services to customers. Preowned is more than just a shopping destination, it's a vibrant community powered by millions of sellers who not only sell their personal style, but also curate looks for their shoppers, creating one of the most connected shopping experiences in the world.</p>
                    <a class="btn-outline-reg" href="#"> Join us!</a>
                </div> 
            </div> 
            <div class="col-lg-6 col-xl-7">
                <div class="image-container">
                    <img class="img-fluid" src="assets/images/details-2.png" alt="alternative" />
                </div> 
            </div> 
        </div>
    </div> 
    </div>
    </div>
</template>
<script>
export default {
    name: 'AboutUs',
}
</script>
<style lang="">
    
</style>